export default "/images/vendor/@material-design-icons/svg/outlined/fast_forward.svg?38ce0d69325552e3008796002defc455";